import { queryOptions } from '@tanstack/react-query';
import { world } from '../../languages';
import { queryClient } from '../../query-client';
import { isForbiddenEndpointsOnPages } from '../../utils/interceptor/is-forbidden-endpoint-on-page';
import { WishlistAuth, getWishlistAuth, wishlistKeys } from './query-keys/query-keys';
import { wishlistMembershipLoaders } from './wishlist-membership-loaders';
import { WISHLIST_MEMBERSHIP_GC_TIME, WISHLIST_MEMBERSHIP_STALE_TIME, WISHLIST_QUERY_URLS } from './wishlist.constants';

// One definition of the per-material check, shared by the hearts (useWishlistMembership) and the on-demand check.
export const getWishlistMembershipQueryOptions = (auth: WishlistAuth, materialId: number) =>
    queryOptions({
        queryKey: wishlistKeys.membership(auth, world, materialId),
        queryFn: async () => (await wishlistMembershipLoaders[auth].load(materialId)) ?? false,
        staleTime: WISHLIST_MEMBERSHIP_STALE_TIME,
        gcTime: WISHLIST_MEMBERSHIP_GC_TIME
    });

// Pages that block wishlist requests (payment) never run the check; the answer there is false.
export const isWishlistMembershipForbidden = (auth: WishlistAuth) =>
    isForbiddenEndpointsOnPages(WISHLIST_QUERY_URLS[auth]);

// Answers from the cache while it is fresh, otherwise asks the server together with the other checks of the same tick.
export const fetchWishlistMembership = (isLoggedIn: boolean, materialId: number): Promise<boolean> => {
    const auth = getWishlistAuth(isLoggedIn);

    if (isWishlistMembershipForbidden(auth)) {
        return Promise.resolve(false);
    }

    return queryClient.fetchQuery(getWishlistMembershipQueryOptions(auth, materialId));
};
